module.exports = __webpack_public_path__ + "assets/f114d0130c3f4d7693fbd4bf1c111c66.png";